import { CommonModule, registerLocaleData } from '@angular/common';
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import localeRu from '@angular/common/locales/ru';
import { HistoryService } from '../services/history';
import { HistoryEventService } from '../services/history.event.service';
import { LogService } from '../services/log.service';

const MODULES: any[] = [
  MatButtonModule,
  MatIconModule,
  MatFormFieldModule,
  FormsModule,
  ReactiveFormsModule,
  CommonModule
];

@Component({
  selector: 'app-history',
  standalone: true,
  imports: [MODULES],
  templateUrl: './history.component.html',
  styleUrl: './history.component.css',
})
export class HistoryComponent {
  public paymentHistory: PaymentHistory[] = [];
  private changeDetectorRef = inject(ChangeDetectorRef);
  private historyService = inject(HistoryService);
  private logService = inject(LogService);
  public HasData: boolean = false;
  public isDataLoaded: boolean = false;

  constructor(
    private historyEventService: HistoryEventService
  ) {
    registerLocaleData(localeRu);
    this.historyEventService.getEvent().subscribe(event => {
      if (event == 'history') {
        this.logService.LogMessage("История платежей. Получено событие " + event);
        this.getHistoryPayments();
      }
    });
  }

  /**
   * Получение и отображение истории платежей
   */
  getHistoryPayments() {
    this.historyService.getPaymentsHistory(false)
      .subscribe(data => {
        this.logService.LogMessage("Получена история платежей");
        this.isDataLoaded = true;
        this.paymentHistory = data;
        this.HasData = data != undefined && data.length > 0;
        this.changeDetectorRef.markForCheck();
      });
  }
}
